import React, { useContext } from 'react'
import { Card } from 'antd'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import GlobalContext from '../GlobalContext'

export default function BoxesMap ({ appointments, selectedBoxes }) {
  const { boxes } = useContext(GlobalContext)

  const percent = (value) => {
    return (value / appointments.length * 100).toFixed(1)
  }

  const boxMarker = (selectedBoxes) => {
    return selectedBoxes.filter(Boolean).map((box) => (
      <Marker position={box.coordinates} key={`map_${box.id}`} >
        <Popup>
          <p>{box.name}</p>
          <p>{`Nb rdv : ${appointments.filter(appointment => appointment.box_id === box.id).length}`}</p>
          <p>{`% rdv : ${appointments.length > 0 ? percent(appointments.filter(appointment => appointment.box_id === box.id).length) : 0}`}</p>
        </Popup>
      </Marker>
    ))
  }

  return (
    <Card>
      <MapContainer center={[47.216671, 2.08333]} zoom={6} scrollWheelZoom={true} style={{ height: '500px', width: '550px' }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {boxMarker(selectedBoxes.map(id => boxes.find(box => box.id === id)))}
      </MapContainer>
    </Card>
  )
}
